import { Action } from '@ngrx/store';
import { IPersonnelState } from '../interfaces/personnel-state.interface';
import * as personnelActions from '../actions/personnel.actions';

export function reducer(state: IPersonnelState, action): IPersonnelState {
  switch (action.type) {
    case personnelActions.UPD_AVAILABLE_STATUSES:
      return Object.assign({}, state, {
        AvailableStatuses: action.payload.List.map(st => ({
          ...st,
          status: st.status.substring(0, 25)
        }))
      });

    default:
      return state;
  }
}
